import { useState } from 'react';
import { useForm } from 'react-hook-form';

import Honeybadger from '@honeybadger-io/js';
import { zodResolver } from '@hookform/resolvers/zod';

const useAuthForm = ({ defaultValues, onSubmit, schema }) => {
  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const form = useForm({
    resolver: zodResolver(schema),
    defaultValues,
  });

  const handleSubmit = async (formData) => {
    try {
      setError(null);
      setIsSubmitting(true);

      await onSubmit(formData, { form, setError });
    } catch (error) {
      setError({ code: error.code || '', message: error.message });
      Honeybadger.notify(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return { error, form, handleSubmit, isSubmitting };
};

export default useAuthForm;
